import styled from 'styled-components';

export default styled.p`
  font-size: ${(props) => props.theme.sizes.text};
  color: ${(props) => props.theme.colors.error};
`;
